import LoginDashboard from '../assets/img/login_dashboard.png';
import ActivationStep from '../assets/img/activation.png';
import SignUpStep from '../assets/img/sign_up_step.png';

export const SIMPLE_STEPS_DATA = [
    {
        id:'1',
        StepNumber: '1',
        StepHeading: 'Login on PayU Dashboard',
        StepDesc:'Select FlexiCash (currently advance settlement) tab on the dashboard',
        StepImageSrc: LoginDashboard,
        ImageAltText: 'Login Dashboard',
    },
    {
        id:'2',
        StepNumber: '2',
        StepHeading: 'Click on apply now',
        StepDesc:'Do your KYC and submit bank account details',
        StepImageSrc:ActivationStep,
        ImageAltText: 'Activation Step',
    },
    {
        id:'3',
        StepNumber: '3',
        StepHeading: 'Activate your line of credit',
        StepDesc:'Place the single line of code at a place of your choice - on a website or blog and accept payments instantly.',
        StepImageSrc:SignUpStep,
        ImageAltText: 'Sign Up Steps',
    }
]